import React, { forwardRef, useMemo } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { CardElementWrapper } from './StripeCard.style';

export const useOptions = () => {
  return useMemo(
    () => ({
      hidePostalCode: true,
      style: {
        base: {
          color: '#1D201F',
          letterSpacing: '0.025em',
          fontFamily: 'Inter, sans-serif',
          '::placeholder': {
            color: '#C1C1C1',
          },
          fontSize: '12px',
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    []
  );
};

type StripeCardProps = React.ComponentProps<typeof CardElement>;

const StripeCard = forwardRef<HTMLDivElement, StripeCardProps>((props, ref) => {
  const options = useOptions();

  return (
    <CardElementWrapper ref={ref}>
      <CardElement {...props} options={options} />
    </CardElementWrapper>
  );
});

export default StripeCard;
